export default function PageMainModule(element) {
    let children = element.querySelectorAll(':scope > *:not(script):not(.ovals)');
    let $last = children[children.length - 1];
    $last.classList.add('last-section-before-footer');
    return this;
}

